import { SubmissionCreationMode } from '@app-types';
import { Button } from '@components';
import { LocalStorageKey } from '@constants';
import { useIsMobile } from '@hooks';
import { Stack, Typography, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

const ConditionsChangedStep: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleClick = (value: SubmissionCreationMode) => {
    navigate('/submission-creation');
    localStorage.setItem(LocalStorageKey.SubmissionCreationMode, value);
  };

  return (
    <Stack alignItems="center" gap={4} sx={{ my: theme.spacing(5) }}>
      <Typography variant="h2" textAlign="center">
        <FormattedMessage id="preparingForNextSubmission.step.3.title" />
      </Typography>
      <Stack direction="row" gap={isMobile ? 2 : 3}>
        <Button variant="outlined" onClick={() => handleClick(SubmissionCreationMode.WithPrefilled)}>
          <FormattedMessage id="common.no" />
        </Button>
        <Button variant="contained" onClick={() => handleClick(SubmissionCreationMode.WithoutPrefilled)}>
          <FormattedMessage id="common.yes" />
        </Button>
      </Stack>
    </Stack>
  );
};

export default ConditionsChangedStep;
